// The gate identity colour. Deliberately not coral: coral means warning everywhere else.
export const TRIGGER_COLOR = 'var(--lureo-lavender)';
export const TRIGGER_COLOR_RGB = '174, 164, 243';
// Warm purple measures 2.23:1 on white, under the 3:1 WCAG 1.4.11 asks of a graphical object. Solid marks,
// lines, outlines, rings and glyphs take warm purple's own hue at 4.5:1 against the theme's ground: darkened on Light,
// lightened on Dark, so it reads as the same colour.
export const TRIGGER_COLOR_DEEP = 'var(--lureo-violet)';
export const TRIGGER_COLOR_DEEP_RGB = '120, 109, 182';
export const TRIGGER_GLYPH_ON_SOLID = 'var(--lureo-on-violet)';
